import { LoopiLogo } from '../../components/LoopiLogo'
//antd
import Spin from 'antd/lib/spin'

const LoadingUser = () => {
    const labels = 'Cargando Datos'

    return <div className="w-full d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div  className="d-flex flex-column align-items-center">
            <LoopiLogo width="150" height="100"  style={{ marginBottom: 10 }} />
            <div>
                <Spin spinning={true} style={{ marginRight: 10 }} />
                {labels}
            </div>
        </div>
    </div>
}

export default LoadingUser